/* ──────────────────────────────────────────────────────────────────────
   Splide touch-swipe fallback.

   Belt-and-suspenders for splide carousels marked with
   <splide-carousel data-touch-fallback>. Splide 4's pointer-event drag
   sometimes doesn't fire on iOS/Android touch in our setup — desktop
   mouse drag works, mobile touch doesn't. Native touchstart/touchend
   listeners translate horizontal swipes into splide.go() calls.

   Passive listeners — does not preventDefault. Vertical scroll still
   works; splide's own drag still runs (this is purely additive). If
   splide IS firing on touch, no harm done; if it isn't, swipe still
   works.

   Listeners attach as soon as the splide-carousel element exists in
   the DOM. The slideInstance is checked at swipe TIME — splide can
   initialise after these listeners are wired without missing the
   event, because the touchend handler queries .slideInstance live.

   Threshold: 30px horizontal delta. Vertical-dominant gestures are
   ignored so page scroll isn't intercepted.
   ────────────────────────────────────────────────────────────── */
(function () {
  var THRESHOLD = 30;

  function initTouchFallback(splideEl) {
    if (!splideEl || splideEl.dataset.touchFallbackInit === '1') return;
    var track = splideEl.querySelector('.splide__track');
    if (!track) return;
    splideEl.dataset.touchFallbackInit = '1';

    var startX = 0;
    var startY = 0;
    var moved = false;

    track.addEventListener('touchstart', function (e) {
      if (!e.touches[0]) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      moved = false;
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      if (!e.touches[0]) return;
      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;
      if (Math.abs(dx) > Math.abs(dy)) moved = true;
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      if (!moved || !e.changedTouches[0]) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) < THRESHOLD) return;
      var s = splideEl.slideInstance;
      if (!s || typeof s.go !== 'function') return;
      s.go(dx > 0 ? '<' : '>');
    }, { passive: true });
  }

  function scan() {
    var els = document.querySelectorAll('splide-carousel[data-touch-fallback]');
    for (var i = 0; i < els.length; i++) initTouchFallback(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  /* Re-scan on Shopify section reload (theme editor + Section Rendering API).
     Keeps newly injected carousels working without a full reload. */
  document.addEventListener('shopify:section:load', scan);

  /* Watch for late-injected carousels (variant-change SRA, drawer mounts). */
  if (typeof MutationObserver !== 'undefined') {
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches('splide-carousel[data-touch-fallback]')) {
            initTouchFallback(n);
          } else if (n.querySelectorAll) {
            var inner = n.querySelectorAll('splide-carousel[data-touch-fallback]');
            for (var k = 0; k < inner.length; k++) initTouchFallback(inner[k]);
          }
        }
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
